import { render, staticRenderFns } from "./input-required-indicator.vue?vue&type=template&id=82a4f15a"
import script from "./input-required-indicator.vue?vue&type=script&lang=js"
export * from "./input-required-indicator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('82a4f15a')) {
      api.createRecord('82a4f15a', component.options)
    } else {
      api.reload('82a4f15a', component.options)
    }
    module.hot.accept("./input-required-indicator.vue?vue&type=template&id=82a4f15a", function () {
      api.rerender('82a4f15a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/shared/components/general/input-required-indicator.vue"
export default component.exports